import { create } from 'zustand';

interface SyncStatus {
  syncing: boolean;
  lastSyncedAt: string | null;
  lastError: string | null;
  initialDone: boolean;
  set: (p: Partial<Omit<SyncStatus, 'set'>>) => void;
}

export const useSyncStatus = create<SyncStatus>((set) => ({
  syncing: false,
  lastSyncedAt: null,
  lastError: null,
  initialDone: false,
  set: (p) => set(p),
}));

let runner: (() => Promise<void>) | null = null;

/** Registered by the sync engine while signed in. */
export function setSyncRunner(fn: (() => Promise<void>) | null): void {
  runner = fn;
}

export async function syncNow(): Promise<void> {
  if (runner) await runner();
}
